import React from 'react';

/**
 * CampoMeseAnno — mese e anno scritti con i numeri: «03/2024», o solo
 * l'anno «2024» dove e' ammesso (Alex, 30/09 e 01/10/2026). UNO SOLO per
 * tutto il frontend: ogni campo «mese» passa da qui.
 *
 * PERCHE' NON IL CAMPO «MESE» DEL BROWSER. Firefox e Safari sul computer non lo
 * hanno: lo mostrano come una casella di testo che accetta solo «2024-03».
 * Chi scrive «03/2024» non riceve nessun errore, e il campo manda un valore
 * VUOTO. Nelle terapie in corso ha fatto perdere 20 date di inizio su 25.
 * Un risultato vuoto sembra un campo lasciato vuoto: e' il difetto peggiore.
 *
 * Il campo tiene il TESTO come lo vede chi scrive; chi lo usa traduce con
 * `aIso` e `daIso`. Solo cifre, la barra la mette il campo, e inputMode apre
 * la tastiera numerica su tablet e telefono.
 */

/** Mentre si scrive: se le prime due cifre sono un mese (01-12) e ne arriva
    una terza, e' mese/anno; altrimenti e' un anno («19…», «20…» non sono
    mesi). Senza `soloAnno` le cifre si leggono sempre come mese/anno. */
export function formattaMeseAnno(testo, soloAnno = false) {
    const c = String(testo || '').replace(/\D/g, '').slice(0, 6);
    if (c.length > 2 && (/^(0[1-9]|1[0-2])/.test(c) || !soloAnno)) return `${c.slice(0, 2)}/${c.slice(2)}`;
    return soloAnno ? c.slice(0, 4) : c.slice(0, 2);
}

/** «03/2024» -> «2024-03»; «2024» -> «2024» se `soloAnno`; altrimenti null. */
export function aIso(testo, soloAnno = false) {
    const t = String(testo || '').trim();
    const m = /^(0[1-9]|1[0-2])\/(\d{4})$/.exec(t);
    if (m) return `${m[2]}-${m[1]}`;
    if (soloAnno && /^\d{4}$/.test(t)) return t;
    return null;
}

/** «2024-03» (o «2024-03-01») -> «03/2024»; «2024» -> «2024». */
export function daIso(iso) {
    const t = String(iso || '');
    const m = /^(\d{4})-(\d{2})/.exec(t);
    if (m) return `${m[2]}/${m[1]}`;
    return /^\d{4}$/.test(t) ? t : '';
}

const CampoMeseAnno = ({ value, onChange, onBlur, soloAnno = false, className = '', ...resto }) => (
    <input
        type="text"
        inputMode="numeric"
        className={`campo-mese-anno ${className}`.trim()}
        value={value}
        maxLength={7}
        placeholder={soloAnno ? 'mm/aaaa o aaaa' : 'mm/aaaa'}
        onChange={(e) => onChange(formattaMeseAnno(e.target.value, soloAnno))}
        onBlur={onBlur}
        {...resto}
    />
);

export default CampoMeseAnno;
